import { AcademicRecognitionType } from "../../types/academicRecognition";

export const ACADEMIC_RECOGNITION_TYPE: { [key in AcademicRecognitionType]: AcademicRecognitionType } = {
  NACID: "NACID",
  UNIVERSITIES: "UNIVERSITIES",
};
